'use es6';

import http from 'hub-http/clients/apiClient';
import compose from 'transmute/compose';
import fromJS from 'transmute/fromJS';
import get from 'transmute/get';
import indexBy from 'transmute/indexBy';
const toMap = compose(indexBy(get('id')), fromJS);
export const getAllUser = () => http.get('users/v2/app/hub-users').then(toMap);